@if (hasFinishedLoadingScores) {
  <div class="d-flex">
    @if (
      {
        productivityScoreEnabled:
          'timeline-productivity' | featureFlagPure | async,
      };
      as data
    ) {
      @if (!data.productivityScoreEnabled && smartScores) {
        <div
          class="d-flex gap-1"
          [nzTooltipOverlayStyle]="{ 'min-width': '18rem' }"
          nz-tooltip
          [nzTooltipTitle]="smartScoretooltipContent"
          [nzTooltipColor]="'#fff'"
        >
          <div>
            <wilson-score-bar
              [widthPercentage]="
                smartScores[ShiftSmartScoreName.ShiftSmartScore]
                  ?.widthPercentage ?? 0
              "
              [backgroundColor]="
                smartScores[ShiftSmartScoreName.ShiftSmartScore]
                  ?.backgroundColor ?? ''
              "
              [size]="size"
            ></wilson-score-bar>
            <div class="text-secondary score-label">
              <span>{{ 'shift.assignment.smart' | translate }}</span
              ><span>{{ 'shift.assignment.score' | translate }}</span>
            </div>
          </div>
          <div class="text-dark ms-1 score-position">
            {{
              smartScores[ShiftSmartScoreName.ShiftSmartScore]?.value ?? '0.0'
            }}
          </div>
          <ng-template #smartScoretooltipContent>
            <wilson-tooltip-smart-score-breakdown
              [smartScores]="smartScores"
            ></wilson-tooltip-smart-score-breakdown>
          </ng-template>
        </div>
      } @else {
        <div>
          <wilson-productivity-score-display
            [userTimeline]="userTimeline"
          ></wilson-productivity-score-display>
        </div>
      }
    }
    @if (
      prefScores &&
      prefScores[ShiftScoreName.ShiftPreferenceScore].widthPercentage > 0
    ) {
      <div
        class="d-flex gap-1"
        [nzTooltipOverlayStyle]="{ 'min-width': '18rem' }"
        nz-tooltip
        [nzTooltipTitle]="prefScoreTooltipContent"
        [nzTooltipColor]="'#fff'"
      >
        <div>
          <wilson-score-bar
            [widthPercentage]="
              prefScores[ShiftScoreName.ShiftPreferenceScore].widthPercentage
            "
            [backgroundColor]="
              prefScores[ShiftScoreName.ShiftPreferenceScore].backgroundColor
            "
            [size]="size"
          ></wilson-score-bar>
          <div class="text-secondary score-label">
            <span>{{ 'shift.assignment.pref' | translate }}</span
            ><span>{{ 'shift.assignment.score' | translate }}</span>
          </div>
        </div>
        <div class="text-dark score-position prefScore-position">
          {{ prefScores[ShiftScoreName.ShiftPreferenceScore].value }}
        </div>
        <ng-template #prefScoreTooltipContent>
          <wilson-tooltip-pref-score-breakdown
            [prefScores]="prefScores"
          ></wilson-tooltip-pref-score-breakdown>
        </ng-template>
      </div>
    }
  </div>
} @else {
  <div class="d-flex">
    <div class="d-flex w-50">
      <nz-skeleton
        class="progress"
        [nzActive]="true"
        [nzParagraph]="{ rows: 1 }"
      ></nz-skeleton>
    </div>
    <div class="d-flex w-50">
      <nz-skeleton
        class="progress ms-1"
        [nzActive]="true"
        [nzParagraph]="{ rows: 1 }"
      ></nz-skeleton>
    </div>
  </div>
}
